







































import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, namespace, Action } from "vuex-class";

import { IPortalUser } from "../../../models/interfaces/authentication/portal-user.model.interface";
import { IPublisher } from "../../../models/interfaces/publisher/publisher.model.interface";
import { IUserPublisherAccess } from "../../../models/interfaces/authentication/user-publisher-access.model.interface";
import Loader from "@/components/Loader.vue";

const PublisherModule = namespace("publisherModule");

@Component({
  components: {
    Loader
  }
})
export default class PublisherAccessTable extends Vue {
  @PublisherModule.Getter public selectedUserPublisherAccess;
  @PublisherModule.Getter public selectedUserAssignedPublisher;
  @PublisherModule.Getter public selectedUserUnassignedPublishers;

  @PublisherModule.Action public retrievePublishers;
  @PublisherModule.Action public retrieveSelectedUserPublishers;

  @PublisherModule.Action public addPublisherAccess;
  @PublisherModule.Action public deletePublisherAccess;

  @Prop() public user: IPortalUser | null;

  @Prop({ default: "Table" })
        public caption: string;

  @Provide() public selectedPublisher: number | null = null;

  @Provide() public unassignedPublishers = [];

  @Provide() public assignedPublishers: IPublisher[] = [];

  @Provide() public isAdmin: boolean = this.getIsAdmin;

  @Provide()
  public columns = [
    { key: "name" },
    {
      key: "options",
      formatter: (value, key, item) => {
        return item;
      }
    }
  ];

  private loading: boolean = true;

  get getUser(): IPortalUser | null {
    return this.user;
  }

  @Watch("getUser")
  public onUserChanged(val: IPortalUser | null, oldVal: IPortalUser | null) {
    if (val) {
      this.isAdmin = this.getIsAdmin;
      this.updatePublishers();
    }
  }

  get getPublisherAccess(): number[] {
    return this.selectedUserPublisherAccess;
  }

  @Watch("getPublisherAccess")
  public onAccessChanged(val: number[], oldVal: number[]) {
    this.selectedPublisher = null;
    this.assignedPublishers = this.selectedUserAssignedPublisher;
    this.unassignedPublishers = this.selectedUserUnassignedPublishers;
  }

  get getIsAdmin(): boolean {
    if (this.getUser && this.getUser.role) {
      return this.getUser.role.id === 1;
    }

    return false;
  }

  public created() {
    this.retrievePublishers().then((result) => {
      if (this.user) {
        this.updatePublishers();
        this.loading = false;
      }
    });
  }

  private updatePublishers() {
    this.loading = true;
    // Reset local publisher props.
    this.assignedPublishers = [];
    this.unassignedPublishers = [];

    if (this.getUser) {
      this.retrieveSelectedUserPublishers(this.getUser.id).then((result) => {
        if (result === true) {
          this.assignedPublishers = this.selectedUserAssignedPublisher;
          this.unassignedPublishers = this.selectedUserUnassignedPublishers;
          this.loading = false;
        }
      });
    }
  }

  private addPublisher() {
    // Check we have a user and a valid choice.
    if (this.getUser && this.selectedPublisher && this.selectedPublisher > 0) {
      const model: IUserPublisherAccess = {
        userId: this.getUser.id,
        publisherId: this.selectedPublisher
      };

      this.addPublisherAccess(model);
    }
  }

  private deletePublisher(publisherId: number) {
    // Check we have a user and a valid choice.
    if (this.getUser && publisherId > 0) {
      const model: IUserPublisherAccess = {
        userId: this.getUser.id,
        publisherId
      };

      this.deletePublisherAccess(model);
    }
  }
}
